import React, { useState, useEffect } from 'react';
import { Table, Button, Modal, Form, Input, Space, App } from 'antd';
import { EditOutlined, DeleteOutlined } from '@ant-design/icons';
import questionService from '../services/question';

const QuestionTypeManage = () => {
  const { message } = App.useApp();
  const [types, setTypes] = useState([]);
  const [loading, setLoading] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);
  const [form] = Form.useForm();
  const [editingId, setEditingId] = useState(null);

  useEffect(() => {
    console.log('QuestionTypeManage 组件加载');
    fetchTypes();
  }, []);

  const fetchTypes = async () => {
    console.log('开始获取题目类型');
    setLoading(true);
    try {
      const response = await questionService.getQuestionTypes();
      console.log('获取题目类型成功:', response);
      if (response && response.data && Array.isArray(response.data.items)) {
        console.log('使用response.data.items作为数据');
        setTypes(response.data.items);
      } else if (response && Array.isArray(response.data)) {
        console.log('使用response.data作为数据');
        setTypes(response.data);
      } else if (Array.isArray(response)) {
        console.log('直接使用response作为数据');
        setTypes(response);
      } else {
        console.log('数据格式不正确，设置为空数组');
        setTypes([]);
      }
    } catch (error) {
      console.error('获取题目类型失败:', error);
      message.error('获取题目类型失败');
      setTypes([]);
    } finally {
      setLoading(false);
    }
  };

  const handleAdd = () => {
    console.log('点击添加按钮');
    setEditingId(null);
    form.resetFields();
    setModalVisible(true);
  };

  const handleEdit = (record) => {
    console.log('点击编辑按钮:', record);
    setEditingId(record.id);
    form.setFieldsValue(record);
    setModalVisible(true);
  };

  const handleDelete = async (id) => {
    console.log('点击删除按钮:', id);
    try {
      await questionService.deleteQuestionType(id);
      console.log('删除成功');
      message.success('删除成功');
      fetchTypes();
    } catch (error) {
      console.error('删除失败:', error);
      message.error('删除失败');
    }
  };

  const handleModalOk = async () => {
    console.log('点击模态框确定按钮');
    try {
      const values = await form.validateFields();
      console.log('表单验证通过，提交数据:', values);
      if (editingId) {
        console.log('更新题目类型:', editingId, values);
        await questionService.updateQuestionType(editingId, values);
        message.success('更新成功');
      } else {
        console.log('创建题目类型:', values);
        await questionService.createQuestionType(values);
        message.success('创建成功');
      }
      setModalVisible(false);
      fetchTypes();
    } catch (error) {
      console.error('操作失败:', error);
      message.error(editingId ? '更新失败' : '创建失败');
    }
  };

  const columns = [
    {
      title: '类型名称',
      dataIndex: 'type_name',
      key: 'type_name',
    },
    {
      title: '类型代码',
      dataIndex: 'type_code',
      key: 'type_code',
    },
    {
      title: '描述',
      dataIndex: 'description',
      key: 'description',
    },
    {
      title: '操作',
      key: 'action',
      render: (_, record) => (
        <Space>
          <Button
            type="link"
            icon={<EditOutlined />}
            onClick={() => handleEdit(record)}
          >
            编辑
          </Button>
          <Button
            type="link"
            danger
            icon={<DeleteOutlined />}
            onClick={() => handleDelete(record.id)}
          >
            删除
          </Button>
        </Space>
      ),
    },
  ];

  console.log('当前状态:', { 
    types, 
    loading, 
    modalVisible, 
    editingId 
  });

  return (
    <div>
      <div style={{ marginBottom: 16 }}>
        <Button type="primary" onClick={handleAdd}>
          添加类型
        </Button>
      </div>
      <Table
        columns={columns}
        dataSource={types}
        rowKey="id"
        loading={loading}
      />
      <Modal
        title={editingId ? '编辑题目类型' : '添加题目类型'}
        open={modalVisible}
        onOk={handleModalOk}
        onCancel={() => setModalVisible(false)}
      >
        <Form form={form} layout="vertical">
          <Form.Item
            name="type_name"
            label="类型名称"
            rules={[{ required: true, message: '请输入类型名称' }]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            name="type_code"
            label="类型代码"
            rules={[{ required: true, message: '请输入类型代码' }]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            name="description"
            label="描述"
          >
            <Input.TextArea />
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
};

export default QuestionTypeManage; 